import React, { createContext, useContext } from "react";

type Flags = Record<string, boolean>;
const defaultFlags: Flags = {};

const FeatureFlagContext = createContext<Flags>(defaultFlags);

export const useFeatureFlags = () => useContext(FeatureFlagContext);


export const FeatureFlagProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    //   const { data: flags = defaultFlags } = useKmstackQuery(["featureFlags"], fetchFlags );

    return (
        <FeatureFlagContext.Provider value={defaultFlags}>
            {children}
        </FeatureFlagContext.Provider>
    );
};



// Big SaaS teams (like Airbnb, GitHub, Shopify) treat flags like temporary toggles, not permanent settings.

// They:

// Use naming conventions like newInvoiceView_temp
// Document flags with TTLs (time to live)
// Set reminders to clean up unused flags
// Use tooling to search/remove flag references